import React from 'react';

// Giriş sonrası açılan boş sayfa. Panel ekranı kaldırıldı (kullanıcı talebi: 2026-09-06);
// Dr.Plazma web'deki gibi burada yalnızca logo duruyor, işler üstteki "Seçenekler"
// menüsünden seçiliyor.
export default function AnaSayfa() {
  return (
    <div style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 14,
      textAlign: 'center',
    }}>
      <img
        src={`${process.env.PUBLIC_URL}/web-big-logo.png`}
        alt="Dr.Plazma — Fizyofiplus Otomasyonu"
        style={{ maxWidth: 'min(620px, 78%)', height: 'auto' }}
      />
    </div>
  );
}
